module.exports = __webpack_public_path__ + "static/media/messenger.cbb1d525.svg";